import { BASE_API_URL } from "~/helper/apiService";

export const SOCKET_URL = BASE_API_URL;

export const todayStr = () => {
  const now = new Date();
  const d = String(now.getDate()).padStart(2, "0");
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const y = now.getFullYear();
  return `${d}/${m}/${y}`;
};

